import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Panel from '@common/Panel'
import { Progress } from 'hljd'
import styles from './style.module.less'
import { Flex } from 'hljd'

@inject('pageStore')
@observer
export default class extends Component {
  render() {
    const {
      pageData: { compete }
    } = this.props.pageStore
    const { champion_score, my_score, top5_avg_score, avg_score } =
      compete || {}
    return (
      <Panel
        title={
          <Flex vc>
            <img
              src="//qnm.hunliji.com/Fs6JEEIZ3APFpgKUurLR5SY5M9d3"
              style={{ marginRight: 10, width: 16 }}
            />
            <span>竞争分析</span>
          </Flex>
        }
      >
        {[
          {
            id: 1,
            title: '同行第一',
            number: champion_score,
            color: '#2FC286'
          },
          {
            id: 2,
            title: '同行TOP5平均',
            number: top5_avg_score,
            color: '#FF801A'
          },
          { id: 3, title: '同行均值', number: avg_score, color: '#CCDBFF' },
          { id: 4, title: '我的店铺', number: my_score, color: '#448AFC' }
        ].map(item => {
          const { id, title, number, color } = item
          const percent = (number / champion_score) * 100

          return (
            <div key={id} className={styles.item}>
              <div className={styles.text}>
                <span className={styles.title}>{title}</span>
                <span
                  className={styles.number}
                  style={{ color: id == 3 ? '#333' : color }}
                >
                  {number || 0}
                </span>
              </div>

              <Progress
                percent={percent}
                showInfo={false}
                strokeColor={color}
              />
            </div>
          )
        })}
      </Panel>
    )
  }
}
